import { ArrowRight, ShieldCheck } from "lucide-react";
import { Button } from "../components/ui/button";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-transparent"
    >
      {/* Subtle grid pattern */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full opacity-[0.03]"
          style={{
            backgroundImage: 'linear-gradient(135deg, #c9a84c 0.5px, transparent 0.5px)',
            backgroundSize: '60px 60px'
          }}
        />
      </div>

      {/* Centered content */}
      <div className="relative z-10 max-w-3xl mx-auto px-6 md:px-12 text-center">
        <div
          data-testid="hero-badge"
          className="inline-flex items-center gap-2 px-4 py-1.5 mb-8 rounded border border-[#c9a84c]/30 bg-[#c9a84c]/5 opacity-0 animate-fade-in-up"
        >
          <ShieldCheck size={14} className="text-gold" />
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">
            Food Safety & HACCP Specialists
          </span>
        </div>

        <h1
          data-testid="hero-headline"
          className="font-heading text-4xl md:text-5xl lg:text-6xl font-medium text-white leading-[1.1] opacity-0 animate-fade-in-up animation-delay-100"
        >
          Where{" "}
          <span className="gold-shimmer">Compliance</span>
          <br />
          Meets Craft.
        </h1>

        <p
          data-testid="hero-subtitle"
          className="mt-6 text-base md:text-lg text-zinc-400 max-w-lg mx-auto leading-relaxed opacity-0 animate-fade-in-up animation-delay-200"
        >
          Professional documentation & HACCP systems for the modern UK food
          business. Built by a chef, for chefs.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10 opacity-0 animate-fade-in-up animation-delay-300">
          <Button
            data-testid="hero-cta-primary"
            asChild
            className="bg-gold hover:bg-[#b8963f] text-black px-8 py-3 text-sm font-semibold rounded transition-colors tracking-wide"
          >
            <a href="#pricing" className="inline-flex items-center gap-2">
              View Packages <ArrowRight size={16} />
            </a>
          </Button>
          <Button
            data-testid="hero-cta-outline"
            asChild
            variant="outline"
            className="border-[#c9a84c]/30 text-gold hover:bg-[#c9a84c]/10 hover:text-white px-8 py-3 text-sm font-medium rounded transition-colors bg-transparent"
          >
            <a href="#about">About Danny</a>
          </Button>
        </div>

        {/* Trust stats */}
        <div className="grid grid-cols-3 gap-6 sm:gap-8 mt-12 lg:mt-16 max-w-md mx-auto opacity-0 animate-fade-in-up animation-delay-400">
          {[
            { value: "20+", label: "Years Experience" },
            { value: "EHO", label: "Inspection Ready" },
            { value: "UK", label: "Nationwide" },
          ].map((stat) => (
            <div key={stat.label} data-testid={`hero-stat-${stat.label.toLowerCase().replace(/\s/g, '-')}`}>
              <p className="font-heading text-2xl md:text-3xl font-medium text-gold">
                {stat.value}
              </p>
              <p className="text-xs text-zinc-500 mt-1 uppercase tracking-wider">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0a0a0a] to-transparent z-10" />
    </section>
  );
}
